export default "__VITE_ASSET__CwDrHvlX__"